import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { Actuacion } from "../../../shared/types";
import { EncabezadoPagina } from "../../components/EncabezadoPagina";
import { CampoBusqueda } from "../../components/Formulario";
import { Insignia } from "../../components/Insignia";
import { Tabla, type ColumnaTabla } from "../../components/Tabla";
import { useToast } from "../../components/Toast";
import { api } from "../../lib/apiClient";

type ActuacionConExpediente = Actuacion & { numero_expediente: string };

export function ActuacionesPage() {
  const { mostrar } = useToast();
  const [actuaciones, setActuaciones] = useState<ActuacionConExpediente[]>([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    api
      .get<{ items: ActuacionConExpediente[] }>("/actuaciones")
      .then((d) => setActuaciones(d.items))
      .catch(() => mostrar("No se pudieron cargar las actuaciones.", "error"))
      .finally(() => setCargando(false));
  }, [mostrar]);

  const filtradas = actuaciones.filter((a) =>
    `${a.descripcion} ${a.numero_expediente} ${a.tipo}`
      .toLowerCase()
      .includes(busqueda.toLowerCase()),
  );

  const columnas: ColumnaTabla<ActuacionConExpediente>[] = [
    { encabezado: "Fecha", render: (a) => a.fecha },
    { encabezado: "Tipo", render: (a) => a.tipo },
    { encabezado: "Descripción", render: (a) => a.descripcion },
    {
      encabezado: "Prioridad",
      render: (a) => <Insignia texto={a.prioridad} tipo="prioridad" />,
    },
    {
      encabezado: "Expediente",
      render: (a) => (
        <Link
          to={`/expedientes/${a.expediente_id}`}
          className="font-medium text-texto transition-colors hover:text-secundario hover:underline"
        >
          {a.numero_expediente}
        </Link>
      ),
    },
  ];

  return (
    <div>
      <EncabezadoPagina
        titulo="Actuaciones"
        descripcion="Historial de actuaciones de todos los expedientes. Se registran desde la ficha de cada expediente."
      />
      <div className="mb-4">
        <CampoBusqueda
          valor={busqueda}
          onCambio={setBusqueda}
          placeholder="Buscar por descripción o expediente..."
        />
      </div>
      <Tabla
        columnas={columnas}
        filas={filtradas}
        claveFila={(a) => a.id}
        cargando={cargando}
        tituloVacio="No hay actuaciones registradas"
        descripcionVacio="Registrá actuaciones desde la pestaña 'Actuaciones' de un expediente."
      />
    </div>
  );
}
